// extracted by mini-css-extract-plugin
module.exports = {"root":"DocumentInfo_root__2O21T"};